"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    commitmentTapeArtifactSlug: v4_1.z
        .string()
        .describe('Commitment file artifact slug'),
    lndTapeArtifactSlug: v4_1.z.string().describe('LND104 file artifact slug'),
    participantTapeArtifactSlug: v4_1.z
        .string()
        .describe('Participant file artifact slug'),
});
exports.nodeType = 'file_valley_bank_sls_commitment';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'valleyBankSlsCommitment';
//# sourceMappingURL=types.js.map